import { render, staticRenderFns } from "./SaveDepartment.vue?vue&type=template&id=72b5c03e&scoped=true"
import script from "./SaveDepartment.vue?vue&type=script&lang=js"
export * from "./SaveDepartment.vue?vue&type=script&lang=js"
import style0 from "./SaveDepartment.vue?vue&type=style&index=0&id=72b5c03e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b5c03e",
  null
  
)

export default component.exports